import React from 'react';
import type { ServiceType, EventType } from '../../../api/types';
import {
  Camera, BookOpen, Book, Clapperboard, Film, Smartphone, Zap,
  Radio, Heart, Sunset, Printer, Image, Palette, Save, User, Video, Circle,
} from 'lucide-react';

export const SERVICE_TYPES: { value: ServiceType; label: string; emoji: React.ReactNode }[] = [
  { value: 'REPORTAGE_FOTO',      label: 'Reportage fotografico',  emoji: <Camera size={16} /> },
  { value: 'ALBUM',               label: 'Album fotografico',       emoji: <BookOpen size={16} /> },
  { value: 'MINI_ALBUM_GENITORI', label: 'Mini album genitori',     emoji: <Book size={16} /> },
  { value: 'VIDEO_MATRIMONIO',    label: 'Film matrimonio',         emoji: <Clapperboard size={16} /> },
  { value: 'TRAILER',             label: 'Trailer',                 emoji: <Film size={16} /> },
  { value: 'REEL',                label: 'Reel social',             emoji: <Smartphone size={16} /> },
  { value: 'SDE',                 label: 'SDE — Same Day Edit',     emoji: <Zap size={16} /> },
  { value: 'DRONE',               label: 'Riprese drone',           emoji: <Radio size={16} /> },
  { value: 'SHOOTING_PRE',        label: 'Shooting pre-evento',     emoji: <Heart size={16} /> },
  { value: 'SHOOTING_POST',       label: 'Shooting post-evento',    emoji: <Sunset size={16} /> },
  { value: 'STAMPA_RISTORANTE',   label: 'Stampa ristorante',       emoji: <Printer size={16} /> },
  { value: 'POSTER',              label: 'Poster',                  emoji: <Image size={16} /> },
  { value: 'STAMPA_FINE_ART',     label: 'Stampa fine art',         emoji: <Palette size={16} /> },
  { value: 'USB_PERSONALIZZATA',  label: 'USB personalizzata',      emoji: <Save size={16} /> },
  { value: 'SECONDO_FOTOGRAFO',   label: 'Secondo fotografo',       emoji: <User size={16} /> },
  { value: 'VIDEOMAKER',          label: 'Videomaker',              emoji: <Video size={16} /> },
  { value: 'ALTRO',               label: 'Altro',                   emoji: <Circle size={16} /> },
];

export const EVENT_TYPES: { value: EventType; label: string }[] = [
  { value: 'MATRIMONIO', label: 'Matrimonio' },
  { value: 'BATTESIMO',  label: 'Battesimo' },
  { value: 'COMUNIONE',  label: 'Comunione' },
  { value: 'CRESIMA',    label: 'Cresima' },
  { value: 'COMPLEANNO', label: 'Compleanno' },
  { value: 'RITRATTO',   label: 'Ritratto' },
  { value: 'ALTRO',      label: 'Altro' },
];

// Category icon/type resolution now handled dynamically via
// @/utils/categoryMapping.ts — use resolveServiceType() and resolveCategoryIcon().

export const svcLabel = (t: ServiceType) => SERVICE_TYPES.find(s => s.value === t)?.label ?? t;
export const svcEmoji = (t: ServiceType): React.ReactNode =>
  SERVICE_TYPES.find(s => s.value === t)?.emoji ?? <Circle size={16} />;
export const marginPct = (cost: number, price: number) =>
  price > 0 ? Math.round(((price - cost) / price) * 100) : 0;
export const marginColor = (pct: number) =>
  pct >= 50 ? 'var(--color-success)' : pct >= 25 ? 'var(--color-warning)' : 'var(--color-error)';
